export const isNonBlankString = s => (
    (typeof s === 'string' || s instanceof String) && s !== ''
)

export default isNonBlankString